import { NgModule } from '@angular/core';
import { ShareModule } from "../share/share.module";
import { RouterModule } from '@angular/router';


//component root
import { ViewPlansComponent } from "./view-plans.component";
//routes
import { ViewPlansRoutes as routes } from "./view-plans.routes";
import { PlansComponent } from './plans/plans.component';
import { BroadbrandComponent } from './broadbrand/broadbrand.component';
import { DevicesComponent } from './devices/devices.component';
import {ModalModule} from "ngx-modal";

@NgModule({
  imports: [
    ShareModule,
    RouterModule.forChild(routes),
    ModalModule,
  ],
  exports:[
    ViewPlansComponent, PlansComponent, BroadbrandComponent, DevicesComponent
  ],
  declarations: [ViewPlansComponent, PlansComponent, BroadbrandComponent, DevicesComponent]
})
export class ViewPlansModule {}
